import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.settings.groupFee', {
    // /context/:ctxId/groups/:groupId/groupfees
    // :ctxId = ancestor/context group, :groupId = group
      url: '/groupfees',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.settings.groupFee.list', {
      url: '',
      template: listTemplate,
      controller: 'GrpFeeListCtrl',
      controllerAs: 'gfvm',
      authenticate: true
    })
    .state('group.view.settings.groupFee.new', {
      url: '/new',
      template: formTemplate,
      controller: 'GrpFeeFormCtrl',
      controllerAs: 'gfvm',
      authenticate: true
    })
    .state('group.view.settings.groupFee.view', {
      url: '/:gfId',
      template: viewTemplate,
      controller: 'GrpFeeViewCtrl',
      controllerAs: 'gfvm',
      authenticate: true
    })
    .state('group.view.settings.groupFee.edit', {
      url: '/:gfId/edit',
      template: formTemplate,
      controller: 'GrpFeeFormCtrl',
      controllerAs: 'gfvm',
      authenticate: true
    });
}];
